import commoncss from "./../../css/common.module.css";
import buttoncss from "./../../css/button.module.css";
import bookclosurecss from "./../../css/bookclosure.module.css";
import Modal from "../../elements/Modal";
import { Button } from "../../elements/Button";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

const LoansModal = ({
  setLoansModal,
}) => {
  const redirectTo = (link) => {
    window.location.href = link;
  };

  return (
    <Modal
      title="Upload Leases"
      bodycss={commoncss.unsetPadding}
      headerActions={
        <CloseIcon
          onClick={() => {
            setLoansModal(false);
          }}
          className="clickable"
        />
      }
      onClose={() => console.log("Modal Closed")}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            onClick={() => {
              setLoansModal(false);
            }}
            label="Cancel"
          />
          <Button
            btnColor={buttoncss.primary}
            label="Proceed"
            onClick={() => {}}
          />
        </>
      }
    >
      <div className={commoncss.pd15}>
        
      </div>
    </Modal>
  );
};

export default LoansModal;
